module.exports = __webpack_public_path__ + "static/U16-faerjestad-3935ca74717e0df988d82db435bda5da.png";